export function RadioButtonIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M12.133 8.668h-.266a3.35 3.35 0 0 0-3.2 3.2a3.333 3.333 0 0 0 3.2 3.464h.136a3.334 3.334 0 0 0 3.328-3.2a3.34 3.34 0 0 0-3.198-3.464m6.938-3.739A9.94 9.94 0 0 0 12.08 2h-.16A10 10 0 0 0 12 22h.081a10 10 0 0 0 6.99-17.071M12 18.667a6.667 6.667 0 0 1-.058-13.334h.118a6.667 6.667 0 0 1-.006 13.333z" />
    </svg>
  );
}
